(function () {
  function morphPrimaryToHighlight(fromOverlay, toOverlay) {
    if (typeof window.gsap === 'undefined' || !fromOverlay || !toOverlay) return;
    var fromEl = fromOverlay.querySelector('.af-feat__svg--primary');
    var toEl = toOverlay.querySelector('.af-feat__svg--highlight');
    if (!fromEl || !toEl) return;
    var fromRect = fromEl.getBoundingClientRect();
    var toRect = toEl.getBoundingClientRect();
    if (!fromRect.width || !toRect.width) return;

    var clone = fromEl.cloneNode(true);
    clone.classList.add('af-feat__svg--morph');
    clone.style.position = 'fixed';
    clone.style.left = fromRect.left + 'px';
    clone.style.top = fromRect.top + 'px';
    clone.style.width = fromRect.width + 'px';
    clone.style.height = fromRect.height + 'px';
    clone.style.margin = '0';
    clone.style.transform = 'none';
    clone.style.transition = 'none';
    clone.style.zIndex = '9999';
    clone.style.pointerEvents = 'none';
    clone.style.opacity = '1';
    document.body.appendChild(clone);

    fromEl.style.visibility = 'hidden';
    toEl.style.transition = 'none';
    toEl.style.opacity = '0';

    var tl = window.gsap.timeline({
      onComplete: function () {
        clone.remove();
        fromEl.style.visibility = '';
        toEl.style.opacity = '';
        toEl.style.transition = '';
      }
    });
    tl.to(clone, {
      duration: 0.9,
      ease: 'power2.inOut',
      left: toRect.left,
      top: toRect.top,
      width: toRect.width,
      height: toRect.height
    }, 0);
    tl.to(clone, { duration: 0.35, opacity: 0, ease: 'power1.in' }, 0.6);
    tl.to(toEl, { duration: 0.4, opacity: 1, ease: 'power1.out' }, 0.55);
  }

  function init(root) {
    var slides = root.querySelectorAll('[data-af-slide]');
    var overlays = root.querySelectorAll('[data-af-overlay]');
    if (!slides.length) return;

    var currentIdx = -1;

    function activate(idx) {
      var prevIdx = currentIdx;
      slides.forEach(function (s) {
        s.classList.toggle('is-active', Number(s.dataset.index) === idx);
      });
      overlays.forEach(function (o) {
        o.classList.toggle('is-active', Number(o.dataset.index) === idx);
      });
      if (prevIdx >= 0 && prevIdx !== idx) {
        morphPrimaryToHighlight(overlays[prevIdx], overlays[idx]);
      }
      currentIdx = idx;
    }

    if (window.matchMedia('(max-width: 1023px)').matches) {
      slides.forEach(function (s) { s.classList.add('is-active'); });
      overlays.forEach(function (o, i) { o.classList.toggle('is-active', i === 0); });
      return;
    }

    var total = slides.length;
    var finalEl = root.querySelector('.af-feat__final');
    activate(0);
    if (total <= 1) return;

    var ticking = false;
    function update() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var scrollable = rect.height - vh;
      if (scrollable <= 0) return;
      var prog = Math.min(1, Math.max(0, -rect.top / scrollable));
      var target = Math.min(total - 1, Math.floor(prog * total));
      var scrollPos = prog * total;
      var finalInView = false;
      if (finalEl) {
        var fr = finalEl.getBoundingClientRect();
        finalInView = fr.top < vh * 0.8 && fr.bottom > 0;
        if (finalInView) target = total - 1;
        finalEl.classList.toggle('is-in-view', finalInView);
      }
      slides.forEach(function (s, i) {
        var sec = s.querySelector('[data-af-secondary]');
        if (!sec) return;
        var img = sec.querySelector('.af-feat__secondary-img');
        if (!img) return;
        var clip = sec.querySelector('[data-af-clip]') || sec;
        var isMockup = sec.classList.contains('af-feat__secondary--mockup');
        var opacityProg = (scrollPos - i) / 2;
        var maxY = Math.max(0, img.offsetHeight - clip.offsetHeight);

        var rawProg;
        if (opacityProg <= 0) rawProg = 0;
        else if (opacityProg >= 1) rawProg = 1;
        else rawProg = Math.max(0, Math.min(1, scrollPos - i));
        if (finalInView && opacityProg > 0) rawProg = 1;

        // Mockup: reveal first (image stays at top), then quickly pan image to the end.
        // Non-mockup: keep legacy single-progress behavior.
        var riseProg, panProg;
        if (isMockup) {
          var riseEnd = 0.35; // mockup fully revealed by 35% of slide scroll
          var panStart = 0.30; // pan begins slightly before reveal completes
          var panEnd = 0.60;   // image reaches bottom by 60% — the "quick" pass-through
          riseProg = Math.max(0, Math.min(1, rawProg / riseEnd));
          panProg = Math.max(0, Math.min(1, (rawProg - panStart) / (panEnd - panStart)));
        } else {
          riseProg = rawProg;
          panProg = rawProg;
        }

        if (isMockup) {
          sec.style.opacity = '1';
          sec.style.setProperty('--af-sec-rise', riseProg.toFixed(4));
        } else {
          if (opacityProg <= 0 || opacityProg >= 1) {
            sec.style.opacity = '0';
          } else {
            var opacity = opacityProg < 0.5 ? opacityProg * 2 : (1 - opacityProg) * 2;
            sec.style.opacity = opacity.toFixed(3);
          }
        }

        sec.style.setProperty('--af-sec-y', (maxY * panProg).toFixed(2));
      });
      if (target !== currentIdx) activate(target);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    root.querySelectorAll('.af-feat__secondary-img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', onScroll, { once: true });
    });
    update();
  }

  document.querySelectorAll('[data-app-features]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-app-features]');
    if (r) init(r);
  });
})();
